import { render, staticRenderFns } from "./MerimenDataList.vue?vue&type=template&id=e89b5b98&scoped=true"
import script from "./MerimenDataList.vue?vue&type=script&lang=js"
export * from "./MerimenDataList.vue?vue&type=script&lang=js"
import style0 from "./MerimenDataList.vue?vue&type=style&index=0&id=e89b5b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89b5b98",
  null
  
)

export default component.exports